<template>
    <div class="fx-g1" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="item_block fx fx-c_center info_row">
            <div class="coverimg" style="margin-left: 147px;">
                <el-image
                    style="width: 150px; height: 90px"
                    :src="lessonSystem.coverImg"
                    :lazy="true"
                    :preview-src-list="[lessonSystem.coverImg]"
                    fit="fill"></el-image>
            </div>

            <div style="width: 180px">{{lessonSystem.name}}</div>

            <div> <el-tag size="mini" effect="dark">{{lessonSystem.typeName}}</el-tag> </div>

            <div style="width: 120px" class="fx-col fx-center">
                <span>课程数量：{{lessonSystem.lessonCount}}</span>
                <span>适合人群：{{lessonSystem.suitCrowd}}</span>
            </div>
            <div class="fx-g1">
                <p>{{lessonSystem.introduction}}</p>
            </div>
        </div>
        <template>
            <el-table
              :data="lessons"
              style="width: 100%">
              <el-table-column
                label="主题名称"
                prop="name">
              </el-table-column>
              <el-table-column
                label="课程简介"
                prop="introduction">
              </el-table-column>
              <el-table-column
                label="课程任务">
                    <template slot-scope="scope">
                        <div v-for="(task,i) in scope.row.tasks" :key="task.id" class="" style="">
                            <div style="">{{i+1}}. {{task.title}}</div>
                        </div>
                    </template>
              </el-table-column>
            </el-table>
        </template>
        <!-- <div v-for="lesson in lessons" :key="lesson.id" class="item_block">
            <div class="fx fx-c_center info_row" style="border-bottom: 1px solid var(--border)">
                <div class="coverimg">
                    <el-image
                        style="width: 150px; height: 90px"
                        :src="lesson.coverImg"
                        :lazy="true"
                        :preview-src-list="[lesson.coverImg]"
                        fit="fill"></el-image>
                </div>

                <div style="width: 380px;" >
                    <div class="lesson_name">{{lesson.name}}</div>
                    <div style="margin-top: 12px">
                        <tag-group :tags="lesson.tagArray" size="mini" style="justify-content: flex-start"></tag-group>
                    </div>
                </div>
                <div class="fx-g1">{{lesson.introduction}}</div>
                <div v-for="(task,i) in lesson.tasks" :key="task.id" class="" style="margin-bottom: 6px">
                    <div style="width: 200px">{{i+1}}. {{task.title}}</div>
                </div>
            </div>
        </div> -->
        <div class="fx fx-m_center" style="position: relative;top: 10px;">
            <el-button type="primary" @click="applyOpen">申请开通</el-button>
        </div>

    </div>

</template>

<style scoped>
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 18px 50px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }

    .coverimg {
        width: 160px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }
</style>

<script>
    import {mapMutations} from "vuex";
    export default {
        components: {
        },
        props: [
            "attr"
        ],
        data() {
            return {
                loading: true,
                showResources: false,
                currentResources: [],

                showVideo: false,
                currentVideo: null,

                showTaskEdit: false,
                currentTask: {},

                showEdit: false,
                showLessonEdit: false,
                currentLesson: {},

                lessonSystem: this.attr.lessonSystem,

                lessons: [],

                taskData: [],
                taskForm:{
                    keywords:"",
                    knowledgeIds:[],
                    checkType : true,
                    type:0
                },
                choosedList:[],
                dialogTableVisible: false,
                options:[],
                currentLessonId:0,
            }

        },

        watch: {
        },
        methods: {
            ...mapMutations(["openTab"]),
            //加载单节课
            loadLesson(lesson) {
                lesson.videos = lesson.resources.filter(r => r.category == 1);
                lesson.plans = lesson.resources.filter(r => r.category == 2);
                lesson.ppts = lesson.resources.filter(r => r.category == 3);
                lesson.codes = lesson.resources.filter(r => r.category == 4);
                lesson.tasks = [];
                let index = -1;

                this.lessons.forEach((item, i) => {
                    if (item.id == lesson.id) {
                        index = i;
                        lesson.tasks = item.tasks;
                        return;
                    }
                })
                if (index == -1) {
                    this.lessons.push(lesson);
                } else {
                    this.$set(this.lessons, index,  lesson);
                }
                this.showLessonEdit = false;
            },
            //加载所有课
            loadLessons() {
                this.$ajaxGet("/lesson/listByCenterSystem/"+this.lessonSystem.id, (data) => {
                    let lessons = data.result;
                    lessons.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.plans = item.resources.filter(r => r.category == 2);
                        item.ppts = item.resources.filter(r => r.category == 3);
                        item.codes = item.resources.filter(r => r.category == 4);
                        item.tasks = null;
                    })
                    this.lessons = lessons;

                    if (lessons.length == 0) {
                        this.loading = false;
                    } else {
                        this.loadTasks(lessons.map(item => item.id));
                    }

                })
            },
            loadTasks(lessonIds) {
                this.$ajaxPost("/lessonTask/listByLessons", {
                    lessonIds: lessonIds
                }, (data) => {
                    data.result.forEach(item => {
                        item.videos = item.resources ? item.resources.filter(i => i.category == 1) : [],
                            item.codes = item.resources ? item.resources.filter(i => i.category == 3) : [],
                            item.tutorials = item.resources ? item.resources.filter(i => i.category == 4) : [],
                            item.attachments = item.resources ? item.resources.filter(i => i.category == 2) : []
                    })
                    this.lessons.forEach(item => {
                        if (lessonIds.some(id => id == item.id)) {
                            item.tasks = data.result.filter(task =>  task.lessonId == item.id);
                        }
                    })
                    this.loading = false;
                    this.showTaskEdit = false;
                })
            },

            loadTaskData() {
                if(this.dialogTableVisible == false){return;}
                this.loadFuncs();
                this.$ajaxPost("/lessonTask/listByPlatFormId", {
                    form: this.taskForm,
                }, (data) => {
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.taskData = items;
                })
            },
            loadSchoolTaskData() {
                if(this.dialogTableVisible == false){return;}
                this.taskForm.type = this.lessonSystem.type;
                this.loadFuncs();
                this.taskForm.lessonId = this.currentLessonId;
                this.$ajaxPost("/lessonTask/listByNotTaskId", {
                    form: this.taskForm,
                }, (data) => {
                    let items = data.result;
                    items.forEach(item => {
                        item.videos = item.resources.filter(r => r.category == 1);
                        item.attachments = item.resources.filter(r => r.category == 2);
                        item.codes = item.resources.filter(r => r.category == 3);
                        item.tutorials = item.resources.filter(r => r.category == 4);
                    })
                    this.taskData = items;
                })
            },
            applyOpen(){
                this.openTab({
                    funcKey: "school_menu_agent_info",
                    title: "系统升级",
                    allowDuplicate: true
                });
            },
            handleChange(value) {
                console.log(value);
            },
        },

        created() {
            this.loadLessons();
            // this.loadFuncs();
        }

    }
</script>
